import { useEffect, useState, useCallback } from "react";

const KEY = "mmedia_studio_saved_v1";

function read() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return [];
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch (_) { return []; }
}

function write(list) {
  try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) { /* noop */ }
  window.dispatchEvent(new Event("mmedia:saved-changed"));
}

export function useSaved() {
  const [saved, setSaved] = useState(() => (typeof window === "undefined" ? [] : read()));

  useEffect(() => {
    const sync = () => setSaved(read());
    window.addEventListener("storage", sync);
    window.addEventListener("mmedia:saved-changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("mmedia:saved-changed", sync);
    };
  }, []);

  const isSaved = useCallback((id) => saved.includes(id), [saved]);

  const toggle = useCallback((id) => {
    const list = read();
    const next = list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
    write(next);
    setSaved(next);
    return next.includes(id);
  }, []);

  const clear = useCallback(() => { write([]); setSaved([]); }, []);

  return { saved, isSaved, toggle, clear };
}
